<template>
  <ion-page>
    <ion-header>
      <HeaderWithBackButtonComponent title="パスワードリセット" :show-button="false" />
    </ion-header>
    <ion-content>
      <div v-if="changeDone">
        <p class="ion-text-center">
          パスワードを変更しました。
        </p>
        <div class="ion-text-center">
          <a class="ion-margin-vertical" style="color: blue; text-decoration: underline" @click="router.push({name: 'WebWithdrawalLogin'})">ログイン画面に戻る</a>
        </div>
      </div>
      <div v-else>
        <p class="ion-text-center">
          新しいパスワードを入力してください<br>
        </p>

        <div class="ion-margin-horizontal">
          <p class="input-label">半角英数8〜20文字</p>
          <PasswordInput v-model="password" placeholder="パスワード" :errors="errors ? errors.password : null" style="margin-bottom: 5px"/>
          <ion-text color="danger" v-if="errors && errors.password" >{{ errors.password }}</ion-text>
        </div>

        <div class="ion-margin-horizontal">
          <p class="input-label">もう一度新しいパスワードを入力してください</p>
          <PasswordInput v-model="password_confirmation" placeholder="パスワード" :errors="errors ? errors.password_confirmation : null" style="margin-bottom: 5px"/>
          <ion-text color="danger" v-if="errors && errors.password_confirm" >{{ errors.password_confirmation }}</ion-text>
        </div>

        <ion-grid class="ion-margin-end">
          <ion-col>
            <ion-button class="primary-button" style="width: 100%" @click="resetPassword()" >次へ</ion-button>
          </ion-col>
        </ion-grid>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonPage,
  IonButton,
  IonContent,
  IonText,
  loadingController,
  LoadingOptions, IonHeader
} from '@ionic/vue'
import { Device } from '@capacitor/device';
import StorageService from '../../utils/StorageService'
import request from '../../utils/Request'
import { useRouter } from 'vue-router';
import { useForm, useFormErrors, useField } from 'vee-validate';
import * as yup from 'yup';
import HeaderWithBackButtonComponent from "@/components/HeaderWithBackButton.vue";
import PasswordInput from "@/components/PasswordInput.vue";
import {ref} from "vue";

const router = useRouter()

const schema = yup.object({
  'password': yup.string()
      .required('パスワードをご入力ください')
      .matches(/^[a-zA-Z0-9]{8,255}$/, 'パスワードが正しくありません'),

  'password_confirmation': yup.string()
      .required('パスワードをご入力ください')
      .matches(/^[a-zA-Z0-9]{8,255}$/, 'パスワードが正しくありません')
})

const formLogin = useForm({
  validationSchema: schema
})

const { value: password } = useField<string>("password")
const { value: password_confirmation } = useField<string>("password_confirmation")

const errors = useFormErrors() as any;
const changeDone = ref(false);

async function resetPassword() {
  const resp = await formLogin.validate();

  if (resp.valid) {
    const deviceInfo = await Device.getInfo()
    const data = {...formLogin.values, ...{
        app_id: import.meta.env.VITE_APP_ID,
        device_uuid: await StorageService.get('deviceUuid'),
        osVersion: deviceInfo.osVersion,
        os: deviceInfo.operatingSystem
      }}

    const loading = await createLoading('送信処理中...')
    await loading.present()
    request.post('/reset-password', data).then((res) => {
      if (res.status) {
        changeDone.value = true;
      }
    }).catch((err) => {
      if (err.response?.status == 422) {
        formLogin.setErrors(err.response.data.errors);
      }
      // formLogin.setErrors({email: ['エラーが発生しました']})
    }).finally(() => {
      loading.dismiss()
    })
  }
}

async function createLoading(msg: string, duration?: number, spinner: LoadingOptions["spinner"] = "crescent") {
  return await loadingController.create({
    message: msg,
    duration: duration,
    spinner: spinner,
  })
}

</script>